import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { TextBox, Combo } from 'fw/forms';

class SecurityAnswers extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            securityAnswers: []
        };
    }

    componentDidMount() {
        let index = 0;

        this.setState({
            // Initialize an array of N items (maxSecurityQuestions)
            securityAnswers: Array.apply(null, Array(this.props.maxSecurityQuestions)).map(() => {
                // Initialie every answer as empty
                let sa = {
                    securityQuestionId: null,
                    answer: ""
                };

                // If there's security answers, we load them in order
                if (this.props.securityAnswers !== undefined && index < this.props.securityAnswers.length)
                    sa = {
                        securityQuestionId: this.props.securityAnswers[index].securityQuestionId.toString(),
                        answer: this.props.securityAnswers[index].answer
                    };

                index++;

                return sa;
            })
        });
    }

    onChange = () => {
        if (this.props.onChange !== undefined)
            this.props.onChange(this.state.securityAnswers);
    }

    onQuestionChange = (index, item) => {
        this.setState({
            securityAnswers: this.state.securityAnswers.map((sa, i) => {
                // Here we need to change a question ID and reset the state (immutable)
                if (item === null)
                    return (i === index) ? { securityQuestionId: null, answer: "" } : sa
                else
                    return (i === index) ? { securityQuestionId: item.value, answer: sa.answer } : sa
            })
        }, this.onChange);
    }

    onAnswerChange = (index, value) => {
        this.setState({
            securityAnswers: this.state.securityAnswers.map((sa, i) => {
                // Here we need to change an answer and reset the state (immutable)
                if (value === "")
                    return (i === index) ? { securityQuestionId: null, answer: "" } : sa
                else
                    return (i === index) ? { securityQuestionId: sa.securityQuestionId, answer: value } : sa
            })
        }, this.onChange);
    }

    render() {
        const Questions = this.state.securityAnswers.map((sa, index) => {
            return (
                <Row key={index}>
                    <Col md={6}>
                        <Combo
                            placeholder="Select a security question"
                            value={sa.securityQuestionId}
                            items={this.props.securityQuestions}
                            clearable={true}
                            searchable={false}
                            onChange={(value) => this.onQuestionChange(index, value)} />
                    </Col>
                    <Col md={6}>
                        <TextBox
                            placeholder="Answer selected security question"
                            value={sa.answer}
                            type="password"
                            onChange={(value) => this.onAnswerChange(index, value)} />
                    </Col>
                </Row>
            )
        });

        return (
            <React.Fragment>
                <span>
                    <h4>Please complete at least <strong>{this.props.requiredSecurityQuestions}</strong> security question from the list below.</h4>
                </span>
                {Questions}
            </React.Fragment>)
    }
}

export default SecurityAnswers


// WEBPACK FOOTER //
// ./src/areas/public/restorePassword/SecurityAnswers.js